import { LabelKey, LabelTextValue } from '.'

interface Props {
  price: number
}
export const Price: React.FC<Props> = ({ price }) => {
  return (
    <div className="sm:flex sm:pb-[6px] w-full text-[15px] sm:text-base leading-9 sm:leading-base align-top sm:align-middle">
      <LabelKey text="定価" />
      <LabelTextValue text={`${price.toLocaleString()}円（税込）`} />
    </div>
  )
}
